'use client';

import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
import { useEffect, useMemo, useState } from 'react';
import { SocialLadderSkeleton } from '@src/components/SocialLadder/SocialLadderSkeleton';
import { configPublic } from '@src/config.public';
import { useSession } from '@src/hooks/useSession';
import { useLocale } from '@src/i18n/LocaleProvider';
import { getBuilderPreviewMode } from '@src/utils/builder.util';
import { cn } from '@src/utils/tailwind';
interface Props {
  className?: string;
  flow: 'ambassadorDashboard' | 'affiliateApplication';
  deviceUUID?: string | null;
  onLoad?: () => void;
  onError?: () => void;
}
export function SocialLadderIframe(t0) {
  const $ = _c(31);
  const {
    className,
    flow,
    deviceUUID,
    onLoad,
    onError
  } = t0;
  const {
    locale
  } = useLocale();
  const {
    user
  } = useSession();
  const {
    edit
  } = getBuilderPreviewMode();
  const [isLoading, setIsLoading] = useState(true);
  user?.email;
  user?.guid;
  let t1;
  if ($[0] !== deviceUUID || $[1] !== locale.lang) {
    t1 = {
      iframeId: "slWebFrame",
      skeleton: SocialLadderSkeleton,
      init: () => {
        if (!deviceUUID) {
          return;
        }
        const areaGuid = configPublic.socialLadder.areaGuid.BodiExperience;
        window.loadSLWebFrame(areaGuid, deviceUUID, "", "", "", locale.lang);
      }
    };
    $[0] = deviceUUID;
    $[1] = locale.lang;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== locale.lang || $[4] !== user?.email || $[5] !== user?.guid) {
    t2 = {
      iframeId: "slWebAppWidget",
      skeleton: null,
      init: () => {
        const areaGuid_0 = configPublic.socialLadder.areaGuid.BodiAffiliates;
        const appGuid = configPublic.socialLadder.appGuid.BodiAffiliates;
        const campGuid = window.getParameterFromURLByName("campGuid");
        const resGuid = window.getParameterFromURLByName("resGuid");
        const crmShopName = configPublic.socialLadder.shopCode.BodiAffiliates;
        const customerEmail = user?.email ?? "";
        const customerId = user?.guid ?? "";
        window.loadSLApplicationWidget(areaGuid_0, appGuid, customerEmail, customerId, campGuid, crmShopName, resGuid, locale.lang);
      }
    };
    $[3] = locale.lang;
    $[4] = user?.email;
    $[5] = user?.guid;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = {
      ambassadorDashboard: t1,
      affiliateApplication: t2
    };
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const flows = t3;
  let t4;
  let t5;
  if ($[10] !== onLoad) {
    t4 = () => {
      const handleMessage = message => {
        if (message.origin == "https://socialladder.rkiapps.com" && message.data.action == "loaded") {
          setIsLoading(false);
          onLoad?.();
        }
      };
      window.addEventListener("message", handleMessage);
      return () => window.removeEventListener("message", handleMessage);
    };
    t5 = [onLoad];
    $[10] = onLoad;
    $[11] = t4;
    $[12] = t5;
  } else {
    t4 = $[11];
    t5 = $[12];
  }
  useEffect(t4, t5);
  if (edit) {
    let t6;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <BuilderPreview />;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    return t6;
  }
  const t6 = flows[flow];
  const t7 = t6.iframeId;
  const t8 = !!flows[flow].skeleton && isLoading;
  let t9;
  if ($[14] !== className || $[15] !== t8) {
    t9 = cn(className, {
      hidden: t8
    });
    $[14] = className;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t6.iframeId || $[18] !== t9) {
    t10 = <div id={t7} className={t9} />;
    $[17] = t6.iframeId;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== flow || $[21] !== flows || $[22] !== isLoading) {
    t11 = !!flows[flow].skeleton && isLoading && flows[flow].skeleton();
    $[20] = flow;
    $[21] = flows;
    $[22] = isLoading;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const t12 = flows[flow];
  let t13;
  if ($[24] !== onError || $[25] !== t12.init) {
    t13 = <Script src="https://socialladder.rkiapps.com/SLWeb/slweb-frame.js" onReady={t12.init} onError={onError} />;
    $[24] = onError;
    $[25] = t12.init;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t13) {
    t14 = <div className="flex w-full justify-center">{t10}{t11}{t13}</div>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
}
function BuilderPreview() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="h-10 rounded bg-gray-200" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex gap-4"><div className="h-10 flex-1 rounded bg-gray-200" /><div className="h-10 flex-1 rounded bg-gray-200" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex gap-4"><div className="h-10 w-24 rounded bg-gray-200" /><div className="h-10 flex-1 rounded bg-gray-200" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex gap-4"><div className="h-10 flex-1 rounded bg-gray-200" /><div className="h-10 flex-1 rounded bg-gray-200" /></div>;
    t4 = <div className="h-5 w-2/3 rounded bg-gray-200" />;
    t5 = <div className="h-5 w-1/2 rounded bg-gray-200" />;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="mx-auto flex w-full max-w-[590px]"><div className="flex w-full flex-col gap-4 rounded-lg border border-gray-300 bg-white p-6">{t0}{t1}{t2}{t3}{t4}{t5}<div className="mt-6 flex items-center justify-between"><div className="h-4 w-12 rounded bg-gray-200" /><div className="h-10 w-24 rounded bg-gray-300" /></div></div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}